import { render, staticRenderFns } from "./PageWorldEvents.vue?vue&type=template&id=34418fbe&scoped=true&"
import script from "./PageWorldEvents.vue?vue&type=script&lang=js&"
export * from "./PageWorldEvents.vue?vue&type=script&lang=js&"
import style0 from "./PageWorldEvents.vue?vue&type=style&index=0&id=34418fbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34418fbe",
  null
  
)

export default component.exports